/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
export const removeDefaultAnchorStyling = function () {
  let withUnderline = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const textDecoration = withUnderline ? 'underline' : 'none';
  return {
    color: 'inherit',
    textDecoration,
    ':active': {
      color: 'inherit',
      textDecoration
    },
    ':focus': {
      color: 'inherit',
      textDecoration
    },
    ':hover': {
      color: 'inherit',
      textDecoration
    },
    ':visited': {
      color: 'inherit',
      textDecoration
    }
  };
};
export const buttonReset = () => ({
  backgroundColor: 'transparent',
  border: 'none',
  font: 'inherit' /* Inherit font settings (doesn’t work in IE7-) */,
  lineHeight: 'normal',
  margin: 0,
  cursor: 'pointer',
  padding: 0
});